// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","HasSeen":"cn_a bht_fm bht_vv bht_xg bht_h"};